import { Horizontal } from '@gravitate-js/excalibrr'
import * as React from 'react'
import { usePointToPointData } from './hooks'
import type { PointToPointTabProps } from './types'
import { PointToPointGrid, CreatePointToPointDrawer, RateHistoryDrawer } from './components'

/**
 * Main component for the Point-to-Point tab in the Ratebook Drill-in view
 * Manages point-to-point data, grids, and drawers
 */
export function PointToPointTab({ ratebook }: PointToPointTabProps) {
  const {
    pointToPoints,
    isLoading,
    refetch,
    gridRef,
    selectedPointToPoint,
    editingPointToPoint,
    drawerVisible,
    historyDrawerVisible,
    openCreateDrawer,
    openEditDrawer,
    openRateHistoryDrawer,
    closeDrawers,
    closeRateHistoryDrawer,
    handlePointToPointSuccess,
  } = usePointToPointData(ratebook)

  return (
    <Horizontal style={{ margin: '0px -1em', height: '100%' }}>
      <PointToPointGrid
        pointToPoints={pointToPoints}
        isLoading={isLoading}
        onEdit={openEditDrawer}
        onViewRateHistory={openRateHistoryDrawer}
        gridRef={gridRef}
        refreshData={refetch}
        ratebook={ratebook}
        onAddPointToPoint={openCreateDrawer}
      />

      <CreatePointToPointDrawer
        ratebook={ratebook}
        visible={drawerVisible}
        onClose={closeDrawers}
        onSuccess={handlePointToPointSuccess}
        editingPointToPoint={editingPointToPoint}
      />

      {selectedPointToPoint && (
        <RateHistoryDrawer
          pointToPoint={selectedPointToPoint}
          open={historyDrawerVisible}
          onClose={closeRateHistoryDrawer}
          onRateChange={refetch}
        />
      )}
    </Horizontal>
  )
}
